export default __webpack_public_path__ + "assets/icon-offer-discount.01470eed.webp";